<template>
  <header class="header share">
    <div class="header__content header__content__left">
      <a href="#" class="logo-share">
        <img class="header__logo" v-if="avatarSource" :src="avatarSource" >
      </a>
    </div>
    <div class="header__content header__content__right">
      <f-breadcrumb />
    </div>
  </header>
</template>

<script>
  import FBreadcrumb from '../Breadcrumb';

  export default {
    name: 'f-header-share',
    components: {
      FBreadcrumb
    },
    data: () => ({
      avatarSource: ''
    }),
    mounted() {
      this.$nuxt.$once('changeAvatar', value => {
        if(value) {
          this.avatarSource = value;
        }
      })
    }
  }
</script>
